import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  {
    root: {
      position: 'relative',
      width: '100%',
    },
  },
  { name: 'GenCustomHtmlBlock' },
);

export default useStyles;
